import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';

const multiEntityDisplayNamePickerField = FormFieldBlueprint.make({
  name: 'multi-entity-display-name-picker',
  params: {
    field: async () => {
      const {
        MultiEntityDisplayNamePicker,
        MultiEntityDisplayNamePickerFieldSchema,
        validateMultiEntityDisplayNamePicker,
      } = await import('./MultiEntityDisplayNamePicker');

      return createFormField({
        name: 'MultiEntityDisplayNamePicker',
        component: MultiEntityDisplayNamePicker,
        schema: MultiEntityDisplayNamePickerFieldSchema,
        validation: validateMultiEntityDisplayNamePicker,
      });
    },
  },
});

const bitbucketRepoDefinitionPickerField = FormFieldBlueprint.make({
  name: 'bitbucket-repo-definition-picker',
  params: {
    field: async () => {
      const {
        BitbucketRepoDefinitionPicker,
        BitbucketRepoDefinitionPickerFieldSchema,
        validateBitbucketRepoDefinitionPicker,
      } = await import('./BitbucketRepoDefinitionPicker');

      return createFormField({
        name: 'BitbucketRepoDefinitionPicker',
        component: BitbucketRepoDefinitionPicker,
        schema: BitbucketRepoDefinitionPickerFieldSchema,
        validation: validateBitbucketRepoDefinitionPicker,
      });
    },
  },
});

const bitbucketRepoBulkEditField = FormFieldBlueprint.make({
  name: 'bitbucket-repo-bulk-edit-field',
  params: {
    field: async () => {
      const {
        BitbucketRepoBulkEditField,
        BitbucketRepoBulkEditFieldSchema,
        validateBitbucketRepoBulkEditField,
      } = await import('./BitbucketRepoBulkEditField');

      return createFormField({
        name: 'BitbucketRepoBulkEditField',
        component: BitbucketRepoBulkEditField,
        schema: BitbucketRepoBulkEditFieldSchema,
        validation: validateBitbucketRepoBulkEditField,
      });
    },
  },
});

const bitbucketRepoMultiPickerField = FormFieldBlueprint.make({
  name: 'bitbucket-repo-multi-picker',
  params: {
    field: async () => {
      const {
        BitbucketRepoMultiPicker,
        BitbucketRepoMultiPickerFieldSchema,
        validateBitbucketRepoMultiPicker,
      } = await import('./BitbucketRepoMultiPicker');

      return createFormField({
        name: 'BitbucketRepoMultiPicker',
        component: BitbucketRepoMultiPicker,
        schema: BitbucketRepoMultiPickerFieldSchema,
        validation: validateBitbucketRepoMultiPicker,
      });
    },
  },
});

const bitbucketPushAccessField = FormFieldBlueprint.make({
  name: 'bitbucket-push-access-field',
  params: {
    field: async () => {
      const {
        BitbucketPushAccessField,
        BitbucketPushAccessFieldSchema,
        validateBitbucketPushAccessField,
      } = await import('./BitbucketPushAccessField');

      return createFormField({
        name: 'BitbucketPushAccessField',
        component: BitbucketPushAccessField,
        schema: BitbucketPushAccessFieldSchema,
        validation: validateBitbucketPushAccessField,
      });
    },
  },
});

const bitbucketAuthField = FormFieldBlueprint.make({
  name: 'bitbucket-auth-field',
  params: {
    field: async () => {
      const { BitbucketAuthField, BitbucketAuthFieldSchema } = await import(
        './BitbucketAuthField'
      );

      return createFormField({
        name: 'BitbucketAuthField',
        component: BitbucketAuthField,
        schema: BitbucketAuthFieldSchema,
      });
    },
  },
});

const bitbucketRepoNameField = FormFieldBlueprint.make({
  name: 'bitbucket-repo-name-field',
  params: {
    field: async () => {
      const { BitbucketRepoNameField, BitbucketRepoNameFieldSchema } =
        await import('./BitbucketRepoNameField');

      return createFormField({
        name: 'BitbucketRepoNameField',
        component: BitbucketRepoNameField,
        schema: BitbucketRepoNameFieldSchema,
      });
    },
  },
});

const bitbucketProjectPickerField = FormFieldBlueprint.make({
  name: 'bitbucket-project-picker',
  params: {
    field: async () => {
      const { BitbucketProjectPicker, BitbucketProjectPickerFieldSchema } =
        await import('./BitbucketProjectPicker');

      return createFormField({
        name: 'BitbucketProjectPicker',
        component: BitbucketProjectPicker,
        schema: BitbucketProjectPickerFieldSchema,
      });
    },
  },
});

const bitbucketProjectKeyField = FormFieldBlueprint.make({
  name: 'bitbucket-project-key-field',
  params: {
    field: async () => {
      const { BitbucketProjectKeyField, BitbucketProjectKeyFieldSchema } =
        await import('./BitbucketProjectKeyField');

      return createFormField({
        name: 'BitbucketProjectKeyField',
        component: BitbucketProjectKeyField,
        schema: BitbucketProjectKeyFieldSchema,
      });
    },
  },
});

const bitbucketProjectNameField = FormFieldBlueprint.make({
  name: 'bitbucket-project-name-field',
  params: {
    field: async () => {
      const { BitbucketProjectNameField, BitbucketProjectNameFieldSchema } =
        await import('./BitbucketProjectNameField');

      return createFormField({
        name: 'BitbucketProjectNameField',
        component: BitbucketProjectNameField,
        schema: BitbucketProjectNameFieldSchema,
      });
    },
  },
});

const bitbucketProjectDefinitionPickerField = FormFieldBlueprint.make({
  name: 'bitbucket-project-definition-picker',
  params: {
    field: async () => {
      const {
        BitbucketProjectDefinitionPicker,
        BitbucketProjectDefinitionPickerFieldSchema,
        validateBitbucketProjectDefinitionPicker,
      } = await import('./BitbucketProjectDefinitionPicker');

      return createFormField({
        name: 'BitbucketProjectDefinitionPicker',
        component: BitbucketProjectDefinitionPicker,
        schema: BitbucketProjectDefinitionPickerFieldSchema,
        validation: validateBitbucketProjectDefinitionPicker,
      });
    },
  },
});

export const scaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    multiEntityDisplayNamePickerField,
    bitbucketAuthField,
    bitbucketProjectPickerField,
    bitbucketProjectKeyField,
    bitbucketProjectNameField,
    bitbucketProjectDefinitionPickerField,
    bitbucketRepoDefinitionPickerField,
    bitbucketRepoMultiPickerField,
    bitbucketRepoBulkEditField,
    bitbucketRepoNameField,
    bitbucketPushAccessField,
  ],
});
